module.exports = __webpack_public_path__ + "img/aghk-bus-selected.43d6258a.svg";